import React from "react";
import LocalizedStrings from 'react-localization';
import { connect } from "react-redux";
import { Grid } from "@mui/material";
import { localisedText } from "../../lib/localisation.es6";
import {
  addEmailTemplateRequest,
  getEmailTemplateRequest,
  deleteEmailTemplateRequest,
  updateEmailTemplateRequest,
  resetAddEmailTemplateSuccess,
  resetAddEmailTemplateError,
  resetDeleteEmailTemplateSuccess,
  resetDeleteEmailTemplateError,
  resetUpdateEmailTemplateSuccess,
  resetUpdateEmailTemplateError
} from "./Redux/actions";
import ButtonInc from "../../shared-ui/ButtonInc";
import BoxInc from "../../shared-ui/BoxInc/Index";
import ViewEmailTemplates from "./components/ViewEmailTemplates";
import AddEmailTemplate from './components/AddEmailTemplate';
import EditEmailTemplate from "./components/EditEmailTemplate";
import AlertDialog from "../../components/AlertDialog/index.es6";
class EmailTemplates extends React.Component {

  constructor(props) {
    const localizedStrings = new LocalizedStrings(localisedText);
    super(props);
    this.state = {
      labels: localizedStrings,
      openUploadEmailTemplateDialog: false,
      showDeleteConfirmation: false,
      templateToDelete: null,
      showDeleteSuccessAlert: false,
      showDeleteErrorAlert: false,
      openEditEmailTemplateDialog: false,
      selectedTemplate: null,
      showUpdateSuccessAlert: false,
      showUpdateErrorAlert: false,
      showAddSuccessAlert: false,
      showAddErrorAlert: false,
    }
  }

  componentWillMount() {
    this.updateLanguage();
    this.props.dispatch(getEmailTemplateRequest());
  }

  componentDidUpdate(prevProps) {
    this.updateLanguage();

    // Handle add success
    if (this.props.emailTemplates.addedEmailTemplate && !prevProps.emailTemplates.addedEmailTemplate) {
      this.setState({
        showAddSuccessAlert: true,
        openUploadEmailTemplateDialog: false,
      });
    }

    // Handle add error
    if (this.props.emailTemplates.addEmailTemplateError && !prevProps.emailTemplates.addEmailTemplateError) {
      this.setState({
        showAddErrorAlert: true,
      });
    }

    // Handle delete success
    if (this.props.emailTemplates.deleteEmailTemplate && !prevProps.emailTemplates.deleteEmailTemplate) {
      this.setState({ 
        showDeleteSuccessAlert: true,
        showDeleteConfirmation: false, 
        templateToDelete: null 
      });
    }

    // Handle delete error
    if (this.props.emailTemplates.deleteEmailTemplateError && !prevProps.emailTemplates.deleteEmailTemplateError) {
      this.setState({ 
        showDeleteErrorAlert: true,
        showDeleteConfirmation: false, 
        templateToDelete: null 
      });
    }

    // Handle update success
    if (this.props.emailTemplates.updatedEmailTemplate && !prevProps.emailTemplates.updatedEmailTemplate) {
      this.setState({
        showUpdateSuccessAlert: true,
        openEditEmailTemplateDialog: false,
        selectedTemplate: null
      });
    }

    // Handle update error
    if (this.props.emailTemplates.updateEmailTemplateError && !prevProps.emailTemplates.updateEmailTemplateError) {
      this.setState({
        showUpdateErrorAlert: true,
      });
    }
  }

  updateLanguage() {
    const language = this.props.globalData.language;
    let resetLanguage = false;
    if (!language) {
      resetLanguage = true;
    }
    const labels = this.state.labels;
    if (resetLanguage || labels.getLanguage() !== language) {
      labels.setLanguage(language);
      this.setState({});
    }
  }

  toggleOpenUploadEmailTemplateDialog(){
    this.setState({openUploadEmailTemplateDialog: !this.state.openUploadEmailTemplateDialog})
  }

  saveEmailTemplate(payload){
    this.props.dispatch(addEmailTemplateRequest(payload));
  }

  openEditEmailTemplate(template){
    this.setState({
      openEditEmailTemplateDialog: true,
      selectedTemplate: template,
    });
  }

  closeEditEmailTemplate(){
    this.setState({
      openEditEmailTemplateDialog: false,
      selectedTemplate: null,
    });
  }

  updateEmailTemplate(payload){
    this.props.dispatch(updateEmailTemplateRequest(payload));
  }

  deleteEmailTemplate(templateGuid){
    this.setState({
      showDeleteConfirmation: true,
      templateToDelete: templateGuid
    });
  }

  confirmDeleteEmailTemplate() {
    if (this.state.templateToDelete) {
      // templateToDelete stays set so the row keeps its spinner
      this.setState({ showDeleteConfirmation: false });
      this.props.dispatch(deleteEmailTemplateRequest(this.state.templateToDelete));
    }
  }

  cancelDeleteEmailTemplate() {
    this.setState({
      showDeleteConfirmation: false,
      templateToDelete: null
    });
  }

  resetDeleteSuccessAlert() {
    this.setState({ showDeleteSuccessAlert: false });
    this.props.dispatch(resetDeleteEmailTemplateSuccess());
  }

  resetDeleteErrorAlert() {
    this.setState({ showDeleteErrorAlert: false });
    this.props.dispatch(resetDeleteEmailTemplateError());
  }

  resetAddSuccessAlert() {
    this.setState({ showAddSuccessAlert: false });
    this.props.dispatch(resetAddEmailTemplateSuccess());
  }

  resetAddErrorAlert() {
    this.setState({ showAddErrorAlert: false });
    this.props.dispatch(resetAddEmailTemplateError());
  }

  resetUpdateSuccessAlert() {
    this.setState({ showUpdateSuccessAlert: false });
    this.props.dispatch(resetUpdateEmailTemplateSuccess());
  }

  resetUpdateErrorAlert() {
    this.setState({ showUpdateErrorAlert: false });
    this.props.dispatch(resetUpdateEmailTemplateError());
  }


  render() {
    const deleting = this.props.emailTemplates.deleteEmailTemplateLoader;

    return (
      <>
        <Grid container spacing={2}>
          <Grid item xs={12} sm={12} md={12}>
            <BoxInc
              expanded
              title="Email templates"
              actionButtons={[
                <ButtonInc
                  variant="contained"
                  color="primary"
                  size="large"
                //hasPermision={hasAuthourity('BULK_ONBOARD_CUSTOMERS')}
                onClick={(event) => {
                  event.stopPropagation()
                  this.toggleOpenUploadEmailTemplateDialog()
                }}
                >
                Upload  Email Template
                </ButtonInc>

              ]}

            >
              <ViewEmailTemplates
              loading={this.props.emailTemplates.getEmailTemplatesloader}
              templates={this.props.emailTemplates.emailTemplates}
              deleteEmailTemplate={this.deleteEmailTemplate.bind(this)}
              editEmailTemplate={this.openEditEmailTemplate.bind(this)}
              deleteLoading={this.props.emailTemplates.deleteEmailTemplateLoader}
              deletingGuid={this.state.templateToDelete}
              />
            <AddEmailTemplate
            open={this.state.openUploadEmailTemplateDialog}
            close={this.toggleOpenUploadEmailTemplateDialog.bind(this)}
            saveEmailTemplate={this.saveEmailTemplate.bind(this)}
            loading={this.props.emailTemplates.addEmailTemplateLoader}
            />
            <EditEmailTemplate
              open={this.state.openEditEmailTemplateDialog}
              template={this.state.selectedTemplate}
              onClose={this.closeEditEmailTemplate.bind(this)}
              onSave={this.updateEmailTemplate.bind(this)}
              loading={this.props.emailTemplates.updateEmailTemplateLoader}
            />
            </BoxInc>
          </Grid>
        </Grid>

        {/* Delete Confirmation Dialog */}
        {this.state.showDeleteConfirmation && (
          <AlertDialog
            show={this.state.showDeleteConfirmation}
            title="Delete Email Template"
            type="warning"
            showConfirm={true}
            showCancel={true}
            confirmBtnText="Yes, Delete"
            cancelBtnText="Cancel"
            onConfirm={this.confirmDeleteEmailTemplate.bind(this)}
            onCancel={this.cancelDeleteEmailTemplate.bind(this)}
            reverseConfirmAndCancelButtons={true}
            style={{ fontSize: '14px' }}
          >
            <div style={{ fontSize: '14px', lineHeight: '1.4' }}>
              <p style={{ margin: '10px 0' }}>Are you sure you want to delete this email template?</p>
              <p style={{ margin: '10px 0' }}><strong>This action cannot be undone.</strong></p>
            </div>
          </AlertDialog>
        )}

        {/* SweetAlert closes itself on confirm, so progress needs its own alert */}
        {deleting && (
          <AlertDialog
            show={true}
            title="Deleting"
            type="custom"
            showConfirm={false}
            showCancel={false}
            style={{ fontSize: '14px' }}
          >
            <div style={{ fontSize: '14px', padding: '10px 0' }}>
              Deleting email template, please wait...
            </div>
          </AlertDialog>
        )}

        {/* Add Success Alert */}
        {this.state.showAddSuccessAlert && (
          <AlertDialog
            show={this.state.showAddSuccessAlert}
            title="Success"
            type="success"
            showConfirm={true}
            confirmBtnText="OK"
            onConfirm={this.resetAddSuccessAlert.bind(this)}
            style={{ fontSize: '14px' }}
          >
            <div style={{ fontSize: '14px', padding: '10px 0' }}>
              Email template has been successfully created.
            </div>
          </AlertDialog>
        )}

        {/* Add Error Alert */}
        {this.state.showAddErrorAlert && (
          <AlertDialog
            show={this.state.showAddErrorAlert}
            title="Error"
            type="error"
            showConfirm={true}
            confirmBtnText="OK"
            onConfirm={this.resetAddErrorAlert.bind(this)}
            style={{ fontSize: '14px' }}
          >
            <div style={{ fontSize: '14px', padding: '10px 0' }}>
              {(this.props.emailTemplates.addEmailTemplateError && this.props.emailTemplates.addEmailTemplateError.message) || 'Unable to create email template. Please try again.'}
            </div>
          </AlertDialog>
        )}

        {/* Delete Success Alert */}
        {this.state.showDeleteSuccessAlert && (
          <AlertDialog
            show={this.state.showDeleteSuccessAlert}
            title="Success"
            type="success"
            showConfirm={true}
            confirmBtnText="OK"
            onConfirm={this.resetDeleteSuccessAlert.bind(this)}
            style={{ fontSize: '14px' }}
          >
            <div style={{ fontSize: '14px', padding: '10px 0' }}>
              Email template has been successfully deleted.
            </div>
          </AlertDialog>
        )}

        {/* Delete Error Alert */}
        {this.state.showDeleteErrorAlert && (
          <AlertDialog
            show={this.state.showDeleteErrorAlert}
            title="Error"
            type="error"
            showConfirm={true}
            confirmBtnText="OK"
            onConfirm={this.resetDeleteErrorAlert.bind(this)}
            style={{ fontSize: '14px' }}
          >
            <div style={{ fontSize: '14px', padding: '10px 0' }}>
              {(this.props.emailTemplates.deleteEmailTemplateError && this.props.emailTemplates.deleteEmailTemplateError.message) || 'Unable to delete email template. Please try again.'}
            </div>
          </AlertDialog>
        )}

        {/* Update Success Alert */}
        {this.state.showUpdateSuccessAlert && (
          <AlertDialog
            show={this.state.showUpdateSuccessAlert}
            title="Success"
            type="success"
            showConfirm={true}
            confirmBtnText="OK"
            onConfirm={this.resetUpdateSuccessAlert.bind(this)}
            style={{ fontSize: '14px' }}
          >
            <div style={{ fontSize: '14px', padding: '10px 0' }}>
              Email template has been successfully updated.
            </div>
          </AlertDialog>
        )}

        {/* Update Error Alert */}
        {this.state.showUpdateErrorAlert && (
          <AlertDialog
            show={this.state.showUpdateErrorAlert}
            title="Error"
            type="error"
            showConfirm={true}
            confirmBtnText="OK"
            onConfirm={this.resetUpdateErrorAlert.bind(this)}
            style={{ fontSize: '14px' }}
          >
            <div style={{ fontSize: '14px', padding: '10px 0' }}>
              {(this.props.emailTemplates.updateEmailTemplateError && this.props.emailTemplates.updateEmailTemplateError.message) || 'Unable to update email template. Please try again.'}
            </div>
          </AlertDialog>
        )}
      </>
    )


  }

}

export default connect((state) => ({
  emailTemplates: state.emailTemplates,
  globalData: state.global,
}))(EmailTemplates);